import { ActionButton, QueryError } from "@components";
import { useAsyncCommand, useDialog, useServices } from "@hooks";
import { AccountingMonth } from "@models";
import { DivisionRouteParams } from "@service/navigation/routes";
import { formatYearMonth } from "@util";
import { awaitWithDeferedCallback } from "@util/helpers";
import React from "react";
import { useRouteMatch } from "react-router-dom";

type Props = {
	accountingMonth: AccountingMonth;
	divisionId: string;
	onChangedStatus: () => void;
};

export default function LockMonthButton(props: Props) {
	const { params } = useRouteMatch<DivisionRouteParams>();
	const { accountingMonthService } = useServices();
	const [handleLockMonth, lockQueryState] = useAsyncCommand(
		() =>
			accountingMonthService.lock(
				params.divisionId,
				props.accountingMonth.month
			),
		{
			rethrowError: true,
		}
	);

	const monthDisplayName = formatYearMonth(props.accountingMonth.month);
	const dlg = useDialog();

	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();

		dlg.showConfirmDialog({
			onConfirm: awaitWithDeferedCallback(
				handleLockMonth,
				props.onChangedStatus
			),
			title: "Monat sperren",
			content: `Monat ${monthDisplayName} sperren? Damit können keine neuen Belege mehr in den Monat geladen werden. 
						Etwaige Belege sollten kontrolliert und der Monat anschließend abgeschlossen werden.`,
			confirmText: "Sperren",
		});
	};

	return (
		<ActionButton onClick={handleClick} query={lockQueryState}>
			Monat sperren
			<QueryError queryState={lockQueryState} />
		</ActionButton>
	);
}
